import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PingGuardServiceFunction } from './core/guard/ping-guard.service';
import { govGuardServiceFunction } from './core/guard/gov-br-guard.service';
import { UnauthorizedComponent } from './features/unauthorized/components/unauthorized.component';
import { animation } from '@angular/animations';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.module').then(m => m.HomeModule),
    data: { state: 'HomePage' }
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/user-home/user-home.module').then(m => m.UserHomeModule),
    data: { state: 'UserHomePage' }
  },
  {
    path: 'manage-profile',
    loadChildren: () =>
      import('./features/manage-profile/manage-profile.module').then(m => m.ManageProfileModule),
    data: { state: 'ManageProfilePage' }

  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [govGuardServiceFunction, PingGuardServiceFunction],
    data: { state: 'UnauthorizedPage' }

  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
